import { createReducer } from '../../app/common/util/reducerUtil';
import { CREATE_SESSION, IS_LOGGED_IN, FETCH_USER, GET_USER_DETAILS, MIGRATION_STATUS, WHO_AM_I } from './AuthConstants';

const initialState = {};

export const createSession = (state, payload) => {
  return Object.assign(state, payload);
}

export const isLoggedIn = (state, payload) => {
  return {
    ...state,
    isLoggedIn: payload,
  };
};

export const fetchUser = (state, payload) => {
  return {
    ...state,
    user: payload,
  };
};

export const getUserDetails = (state, payload) => {
  return {
    ...state,
    profile: payload,
  };
};

export const migrationStatus = (state, payload) => {
  return {
    ...state,
    migration: payload,
  }
}

export const whoami = (state, payload) => {
  return {
    ...state,
    whoami: payload,
  };
};

export default createReducer(initialState, {
  [CREATE_SESSION]: createSession,
  [IS_LOGGED_IN]: isLoggedIn,
  [FETCH_USER]: fetchUser,
  [GET_USER_DETAILS]: getUserDetails,
  [WHO_AM_I]: whoami,
  [MIGRATION_STATUS]: migrationStatus,
});